import EditableLable from "../../../../../../components/miscellany/editable_label/editable_label"
import ToggleButton from "@components/miscellany/toggle_button/toggle_button"
import ChartList from "./chart_list/chart_list"
import store from "./store"
import _http_v1 from '../../../../../../http_requests/_http_v1'
import spinners from "@components/loader/spinners"
import Progress from "./progress/progress"
import Grid from "./grid/grid"
import('./view.css')

export default function Edit(opts={}){
    
    let parameter_id = opts.parameter_id || ''
    let modal_id = "#modal_config_view"
    let chartListComponent,progressComponent, editableLabelViewName, submitButton, gridComponent
    let view_name = 'NOVA VIEW'
    let context = this
    BaseConstructor.call(this)

    this.hide = () =>{
        $(modal_id).modal('hide')
    }

    this.loading = boolean =>{
        $('.config-view-loading-container').toggleClass('show', boolean)
    }

    this.error = _ =>{
        $('.chart-list-container').html(`<div class='flex flex-v-center flex-h-center flex-gap'>Erro ao carregar configurações</div>`)
    }

    init()

    function init(){
        $(modal_id).modal('show')
        
        //definindo containers do componente
        setStage()

        //inicializando componente com listagem de gráficos
        chartListComponent = new ChartList({container: '.chart-list-container'})
        progressComponent = new Progress({container: '.chart-view-progress-config-container'})
        // gridComponent = new Grid({container: '.chart-view-grid-config-container'})

        if(parameter_id){
            //adicionando spinner informando carregamento
            context.loading(true)
            
            //buscando parametro
            _http_v1.request(`parameters/${parameter_id}`, 'get').then(data=>{
                //definindo lista de gráficos no store
                store.setCharts(Object.values(data.values.charts))

                //atualizando progress_bar configs
                store.setProgresBarOptions(data.values.progress_bar || {options:{}})

                //setando o nome da view
                view_name = data.values.view_name
                editableLabelViewName.setText(view_name)

                //adicionando editableLabel com o nome da view
                $('.view-name-container').html(generateTitle())

                progressComponent.generate()

                // gridComponent.generate()
            }).fail(_=>{
                
                context.error()
            }).always(_=>{
                context.loading(false)
            })
        } else {
            //nova view, definindo alguns vvalores iniciais

            //tem que ter ao menos um gráfico (né)
            store.setCharts([{chart_name: 'chart #1'}])

            //limpando configurações da progress bar (definindo default's)
            store.setProgresBarOptions({options: {color: '#f74f78', position: 'top'}, show:true})
            
            //gerando component de progressBar configs
            progressComponent.generate()
        }

        
    }

    function setStage(){
        editableLabelViewName = new EditableLable({text: view_name, text_options:{customClass:'label-view-title', attr_title: 'Título da View'}})
        $('.view-name-container').html(generateTitle())
        $('.config-view-loading-container').html('<div class="flex flex-v-center flex-h-center flex-v"><div class="mb-2">'+spinners.defaultSpinner(1, '', 'md')+'</div><div class="font-weight-bold font-size-lg">Carregando informações da View</div></div>')
        editableLabelViewName.on('value-updated', data=>{
            view_name = data.current
        })

        submitButton = new ToggleButton({container:'.submit-button-container', states:[{title: 'salvar', active:true}, {title:'salvando', active:false}]})
        submitButton.generate()

        let cancel_button = context.createElement('button')
        cancel_button.type = 'button'
        cancel_button.innerHTML = 'Cancelar'

        $('.submit-button-container').append(cancel_button)

        submitButton.on('click', () =>{
            console.log('salvado', store.getProgressBarOptions())
            _http_v1.request(`parameters/${parameter_id}`, 'post', {
                parameter: {
                    parameter_type_id:2, //ChartProductView type
                    values: {
                        view_name: view_name,
                        charts: store.getCharts().map(x=> ({chart_name: x.chart_name, stations_list: x.stations_list, series: x.series, statistics: x.statistics})),
                        progress_bar: store.getProgressBarOptions()
                    }
                },
                to_current_user: true
            }).then(_=>{
                context.trigger('edit-view:save')
            })

            
        })

        $(cancel_button).on('click', _ =>{
            context.trigger('edit-view:cancel')
            setTimeout(_=>{
                if(chartListComponent){
                    chartListComponent.clearList()
                }
            },300)
        })
    }

    function generateTitle(){
        let el = context.createElement('div', 'flex flex-h-space-between flex-v-center mb-3')
        let desc = context.createElement('div', 'text-muted font-size-sm font-weight-bold', 'EDITAR VIEW')
        $(el).append(editableLabelViewName.getElement(), desc)
        return el
    }
}

Edit.prototype = Object.create(BaseConstructor.prototype)